module.exports = __webpack_public_path__ + "static/img/浮标A4.11de8db1.png";